import { gql } from "@apollo/client";
import { x } from "@xstyled/styled-components";
import { forwardRef } from "react";

import { LetterIcon } from "@/components/LetterIcon";
import { NamedIcon } from "@/components/NamedIcon";

export const ExposureIcon = forwardRef(({ exposure, ...props }, ref) => {
  if (exposure.icon) {
    return (
      <NamedIcon
        ref={ref}
        name={exposure.type === "print" ? "PaperCopy" : exposure.icon}
        aria-label={exposure.label}
        {...props}
      />
    );
  }
  if (exposure.acronym) {
    return (
      <x.svg as={LetterIcon} ref={ref} aria-label={exposure.label} {...props}>
        {exposure.acronym}
      </x.svg>
    );
  }
  return null;
});

ExposureIcon.fragments = {
  exposure: gql`
    fragment ExposureIcon_exposure on Exposure {
      id
      label
      icon
      acronym
      enabled
      type
      delayedVsArticlePublication
      requiredPriorArticlePublication
    }
  `,
};
